import global from '../patterns/global-variables';
import $ from 'jquery';
window.jQuery = $;
import './vendor/jquery.validate.min.js';
import modal from '../patterns/modal.js';
import utils from '../patterns/utils';
import PL_utils from '../patterns/pl-utils.js';


const body = document.querySelector('body');

const modalHooks = {
    _hasScrolledToBottom: false,
    _addModalError: function (target) { },
    _removeModalError: function (target) { },
    beforeOpen: function (target) {
        PL_utils.addClass('modal-open', body);
    },
    afterOpen: function (target) { },
    onContinue: function (e, target) { },
    onCancel: function () {
        return false;
    },
    beforeClose: function () {
        document.querySelectorAll('.modal').forEach((item) => {
            if (!item.getAttribute("hidden")) {
                item.setAttribute('hidden', "");
                item.setAttribute("aria-hidden", true);
            }
        });
        return false;
    },
    afterClose: function () {
        PL_utils.removeClass('modal-open', body);
        document.querySelector('#validate-credentials').focus();
    },
    setSize: function () {
        return false;
    },
    onScreenshot: function () {
        return false;
    },
    onInit: function (target) {

    }
};

const modalOpts = {
    enableBackdropClose: true
};

const showSentModal = () => {
    const sentModalEl = document.querySelector('.modal-login-verification-sent');
    const sentModal = modal.initModal(sentModalEl, modalHooks, modalOpts);
    applyAccessibility(sentModalEl);
    sentModal.showModal();
    sentModalEl.focus();
};

const applyAccessibility = (ModalEle) => {
    const el_label = ModalEle.querySelector("[data-label]");
    if (el_label != null && !global.IS_ED_MODE) {
        ModalEle.setAttribute("aria-labelledby", el_label.innerHTML);
        ModalEle.setAttribute("role", "dialog");
        ModalEle.setAttribute("aria-modal", "true");
        ModalEle.removeAttribute("hidden");
        ModalEle.removeAttribute("aria-hidden");
        ModalEle.setAttribute("tabIndex", "0");
    }
};


export default () => {
    const modalEL = document.querySelector('.modal-login-email-error2');
    const editemailbtn = modalEL.querySelector('.edit-email');
    const editemailCancelbtn = modalEL.querySelector('.edit-email-cancel');
    const verifyEmailEl = modalEL.querySelector('.verify-email');
    const verifyEmailInputEl = modalEL.querySelector('.validate-email');

    $('#email-edit-form').validate({
        rules: {
            'email-edit': {
                required: true,
                email: true,
                pattern: "^(?!(abuse|admin|administrator|groupadmin|info|webmaster|postmaster|support)@)(([0-9a-zA-Z])+([-._'+&]))*[0-9a-zA-Z]+@([-0-9a-zA-Z]+[.])+[a-zA-Z]{2,6}$"
            }
        },
        showErrors: function (errorMap, errorList) {
            // The arguments in errorList contain only those elements currently validated.
            // Refer to the form.successList for all the valid field,
            // and remove the error message that's associated to it.
            // Ref: https://jqueryvalidation.org/validate/  => showErrors
            this.successList.forEach((e) => {
                const targetName = e.name;
                const targetElements = $(`[name='${targetName}']`);
                const errorElement = $(`#${targetName}-label .form-error`);

                $(targetElements).removeClass('error');
                errorElement.addClass('hidden');
            });

            errorList.forEach((error) => {
                const targetName = error.element.name;
                const { method } = error;
                const targetElements = $(`[name='${targetName}']`);
                const errorElement = $(`#${targetName}-label .form-error`);

                targetElements.addClass('error');
                errorElement.removeClass('hidden');

                window.dataLayer.push({ 'event': 'Form_Error', 'Form_Name': 'Registration', 'Form_Field': targetName, 'Form_Field_Error': errorElement.text(), });

                $(targetElements).attr('aria-invalid', 'true');
            });
        },
        submitHandler: function (form) {
            //Submit the form
            window.dataLayer.push({ 'event': 'Form_Success', 'Form_Name': 'Registration', });

            const formData = $(form).serializeArray();
            const postData = { 'anonymousToken': utils.getAnonymousToken() };

            formData.forEach(function (field) {
                postData[field.name] = field.value;
            });

            utils.setButtonLoadingState('#resend-verification', '#resend-verification-loading', true);

            // Send Verification Email
            $.ajax(global.API_ENDPOINT() + '/user/verify-email', {
                data: JSON.stringify({ userToken: postData['userToken-edit'], email: postData['email-edit'] }),
                dataType: 'json',
                method: 'POST',
                xhrFields: {
                    withCredentials: true,
                }
            })
            .done(function (resp) {
                if (resp.success) {
                    PL_utils.removeClass('modal--active', modalEL);
                    showSentModal();
                } else {
                    console.error(JSON.stringify(resp));
                }
                utils.setButtonLoadingState('#resend-verification', '#resend-verification-loading', false);
            })
            .fail(function (err) {
                console.error(JSON.stringify(err));
                utils.setButtonLoadingState('#resend-verification', '#resend-verification-loading', false);
            })
        }
    });

    const updatEmail = () => {
        PL_utils.addClass("hidden", verifyEmailEl);
        PL_utils.addClass("hidden", editemailbtn);
        PL_utils.removeClass("hidden", verifyEmailInputEl);
        PL_utils.removeClass("hidden", editemailCancelbtn);
    };

    const resetEmail = () => {
        PL_utils.removeClass("hidden", verifyEmailEl);
        PL_utils.removeClass("hidden", editemailbtn);
        PL_utils.addClass("hidden", verifyEmailInputEl);
        PL_utils.addClass("hidden", editemailCancelbtn);
        const emailInputEl = modalEL.querySelector('#email-edit');
        const verifyEmailText = modalEL.querySelector('.verify-email strong');
        emailInputEl.value = verifyEmailText.innerText;
    };

    if (editemailbtn) {
        PL_utils.eleOnClick(function (e) {
            e.preventDefault();
            updatEmail();
        }, editemailbtn);
    }

    if (editemailCancelbtn) {
        PL_utils.eleOnClick(function (e) {
            e.preventDefault();
            resetEmail();
        }, editemailCancelbtn);
    }

    //screenshot
    if (window.location.href.indexOf('ed=1') > -1) {
        if (window.location.search.substring(1).split('&').indexOf('modal=email3') > -1) {
            updatEmail();
        } else if (window.location.search.substring(1).split('&').indexOf('modal=sent') > -1) {
            showSentModal();
        }
    }


}

